import {
  API_ENDPOINT,
  useClientApiV4AuthSignupCreateMutation,
} from '../../resources/@types/accountSchema';

interface UseClientV4AuthSignupMutation {
  options?: Parameters<typeof useClientApiV4AuthSignupCreateMutation>[0]['options'];
}

export function useAuthSignupCreateMutation({ options }: UseClientV4AuthSignupMutation) {
  return useClientApiV4AuthSignupCreateMutation({
    url: API_ENDPOINT.CLIENT_V4_AUTH_SIGNUP,
    options,
  });
}
